import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './app/styles/app.css';
import './app/styles/studio.css';
import './app/styles/studio-image-editor.css';
import './app/styles/studio-video-editor.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
